<template>
  <div>
    <v-dialog
      v-model="paymentDialog"
      max-width="490"
    >
      <v-card>
        <v-card-title class="headline">
          {{method === "insurance" ? "For Billing Insurance" : "Paying with my credit card" }}
        </v-card-title>
        <v-divider></v-divider>

        <v-card-text class='pt-3'>

          <p
            v-if='method !== "cc"'
            class='subtitle-1 font-weight-bold'
          >Please click on the "Redeem Coupon" button and use the below code to schedule for the appointment
          </p>

          <h3 class='subtitle-1 font-weight-bold'>{{method === "insurance" ? "INSURANCEONLY" : form.couponCode}} </h3>

          <p
            v-if='method === "cc"'
            class='subtitle-1 font-weight-bold'
          >I do not wish to have information released to my insurance and prefer to pay upfront for the visit. The cost of the visit if paid prior to, or at the time of the genetic counseling visit is $200 for a new patient consult. I understand I may submit claims to insurance at my discretion. </p>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="paymentDialog = false"
          > {{method === "insurance" ? "Disagree": "Back"}}

          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="billing()"
          >
            {{method === "insurance" ? "Agree": "Continue"}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="insuraceDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="insuraceDialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Financial Assistance Application</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>

          </v-toolbar-items>
        </v-toolbar>

        <financialAssistance @complete='insuraceDialog = false; paymentDialog = false;' />

      </v-card>
    </v-dialog>

    <v-card>
      <v-card-title>Payment Option</v-card-title>
      <v-divider></v-divider>
      <h4 class='ma-5'>Patient Financial Responsibilities</h4>
      <p class='ma-5'>
      <ul>

        <li>
          The patient (or patient’s guardian, if a minor) is ultimately responsible for the payment for his/her treatment and care.
        </li>
        <li>We are pleased to assist you by billing your insurance. However, the patient is required to provide us with the most correct and updated information about their insurance, and will be responsible for any charges incurred if the information provided is not correct or updated.</li>
        <li>If the appointment is not covered by your insurance, you will be billed the full cost of the appointment, which is $250. If you choose to not go through your insurance and pay for the visit out-of-pocket, the prompt pay price for an appointment is $200 (must be paid at or before the time of your appointment).</li>
        <li>
          Patients may incur, and are responsible for the payment of additional charges at the discretion of Genetic Support Foundation. These charges may include: Any costs associated with collection of patient balances.
        </li>
      </ul>

      </p>
      <v-card-text>
        <v-row>
          <v-col
            cols="12"
            md="4"
          >
            <v-hover v-slot="{ hover }">
              <v-card
                :disabled="form.paymentMethod !== 'insurance'"
                :elevation="hover ? 12 : 2"
                style='cursor:pointer'
                class="d-flex align-center"
                @click="insurance"
                height="200"
              >

                <v-card-text class="font-weight-medium mb-5  text-center subtitle-1">

                  <p>
                    <v-icon
                      size='50'
                      color="green darken-2"
                    >
                      mdi-medical-bag
                    </v-icon>
                  </p>
                  You selected to bill your insurance for the genetic counseling appointment
                </v-card-text>

              </v-card>
            </v-hover>
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-hover v-slot="{ hover }">
              <v-card
                :disabled="form.paymentMethod !== 'fa'"
                @click='insurance'
                :elevation="hover ? 12 : 2"
                class="d-flex align-center"
                style='cursor:pointer'
                height="200"
              >
                <v-card-text class="font-weight-medium  text-center subtitle-1">
                  <p>
                    <v-icon
                      size='50'
                      color="green darken-2"
                    >
                      mdi-clipboard-account-outline
                    </v-icon>
                  </p>
                  You applied for financial assistance
                </v-card-text>

              </v-card>
            </v-hover>
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-hover v-slot="{ hover }">
              <v-card
                :disabled="form.paymentMethod !== 'cc'"
                :elevation="hover ? 12 : 2"
                style='cursor:pointer'
                class="d-flex align-center"
                @click='creditcard'
                height="200"
              >

                <v-card-text class="font-weight-medium mb-5  text-center subtitle-1">

                  <p>
                    <v-icon
                      size='50'
                      color="green darken-2"
                    >
                      mdi-credit-card
                    </v-icon>
                  </p>
                  You selected pay for the visit using my credit card
                </v-card-text>

              </v-card>
            </v-hover>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          text
          @click='$emit("back")'
        >
          <v-icon
            right
            dark
          >
            mdi-chevron-left
          </v-icon>
          Back
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import financialAssistance from "./FinancialAssistance";
import { stateList } from "../data/dataSource";
import { mapFields } from "vuex-map-fields";
export default {
  components: {
    financialAssistance,
  },
  computed: {
    ...mapFields([
      "form",
      "selectedStateID",
      "selectedMonth",
      "selectedDate",
      "selectedGC",
      "selectedTime",
      "doctorReferece",
      "userProfile",
    ]),
  },
  data() {
    return {
      paymentDialog: false,
      insuraceDialog: false,
      method: null,
    };
  },
  methods: {
    getInsuraceState(selectedStateID) {
      return stateList().find((s) => s.stateID === selectedStateID).insuraceID;
    },
    formatReason(input) {
      switch (input) {
        case "1":
          return "Personal or family history of cancer";
        case "2":
          return "Personal or family history of heart conditions";
        case "3":
          return "Personal or family history of a neurological or neuromuscular condition";
        case "4":
          return "Current or future pregnancy";
        case "5":
          return "Personal or family history of a connective tissue disorder";
        case "6":
          return "Other (please specify)";
      }
    },
    billing() {
      console.log(this.form);
      let completeAddress = `${this.form.address}`;
      let confirm_url = `12813864&appointmentType=${
        this.selectedStateID
      }&firstName=${this.form.firstName}&lastName=${this.form.lastName}&phone=${
        this.form.phone
      }&email=${this.form.email}&calendarID=${this.selectedGC}&datetime=${
        this.selectedTime
      }&field:2129808=${this.form.dob}&field:4238346=${
        this.form.secondPhone
      }&field:4224412=${completeAddress}&field:4224409[]=${
        this.form.gender
      }&field:3972587[]=${this.formatReason(this.form.reason)}&field:2129805=${
        this.form.notes
      }&field:2143746=${this.form.firstTime}&timezone=${
        this.form.timezone.name
      }&field:7227834=${this.form.aboutGSF}`;
      confirm_url = this.doctorReferece
        ? confirm_url + `&field:10106009=${this.userProfile.recordNumber}`
        : confirm_url;
      let formattedURL = encodeURI(confirm_url);
      formattedURL = formattedURL.replace(/#/g, "%23");
      formattedURL = formattedURL.replace("+", "%2b");
      let url =
        "https://app.acuityscheduling.com/schedule.php?owner=" + formattedURL;

      if (this.method === "insurance") {
        let confirm_url = `12813864&appointmentType=${this.getInsuraceState(
          this.selectedStateID
        )}&firstName=${this.form.firstName}&lastName=${
          this.form.lastName
        }&phone=${this.form.phone}&email=${this.form.email}&calendarID=${
          this.selectedGC
        }&datetime=${this.selectedTime}&field:9184733=${
          this.form.dob
        }&field:9184730=${this.form.secondPhone}&field:9184732=${
          this.form.address
        }&field:9184731[]=${
          this.form.gender
        }&field:9184735[]=${this.formatReason(
          this.form.reason
        )}&field:9184736=${this.form.notes}&field:9184734=${
          this.form.firstTime
        }&timezone=${this.form.timezone.name}&field:9184737=${
          this.form.aboutGSF
        }`;
        let formattedURL = encodeURI(confirm_url);
        formattedURL = formattedURL.replace(/#/g, "%23");
        formattedURL = formattedURL.replace("+", "%2b");
        url =
          "https://app.acuityscheduling.com/schedule.php?owner=" + formattedURL;

        console.log(this.form);
      }
      window.open(url);
      this.paymentDialog = false;
    },
    creditcard() {
      this.method = "creditcard";
      this.paymentDialog = true;
    },
    insurance() {
      this.method = "insurance";
      this.paymentDialog = true;
    },
  },
};
</script>